// @ts-ignore
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { routerBeforeEach } from '@/interceptor/routerInterceptor'

// @ts-ignore
// @ts-ignore
const routes: Array<RouteRecordRaw> = [
  {
    path: '/activity',
    component: () => import('@/components/Layout.vue'),
    meta: {
      title: '活动',
    },
    children: [
      {
        path: 'givingVideoMedicalBox',
        // name: 'GivingVideoMedical',
        meta: {
          title: '消费达标,送视频医生',
          needLogin: true,
          navbar: false,
          goBackApp: true,
        },
        component: () =>
          import('@/views/activity/givingVideoMedical/GivingVideoMedical.vue'),
      },
      {
        path: 'givingVideoMedical',
        // name: 'GivingVideoMedical',
        meta: {
          title: '消费达标,送视频医生',
          navbar: false,
          needLogin: true,
          goBackApp: true,
        },
        component: () =>
          import('@/views/activity/givingVideoMedical/GivingVideoMedical.vue'),
      },
      {
        path: 'medicalService',
        meta: {
          title: '体检活动',
          navbar: false,
          goBackApp: true,
          needLogin618: true
        },
        component: () => import('@/views/activity/medicalService/index.vue')
      },
      {
        path: 'changAnMind',
        meta: {
          title: '长安心',
          navbar: false,
          goBackApp: true,
          needLogin618: true
        },
        component: () => import('@/views/activity/changAnMind/index.vue')
      },
      {
        path: 'cancerDetection',
        meta: {
          title: '胃肠癌检测',
          navbar: false,
          goBackApp: true,
          needLogin618: true
        },
        component: () => import('@/views/activity/cancerDetection/index.vue')
      },
      {
        path: 'rehabilitateNurse',
        meta: {
          title: '康复护理',
          navbar: false,
          goBackApp: true,
          needLogin618: true
        },
        component: () => import('@/views/activity/RehabilitateNurse/index.vue')
      },
      {
        path: 'riTzCheck',
        meta: {
          title: '瑞慈体检',
          navbar: false,
          goBackApp: true,
          needLogin618: true
        },
        component: () => import('@/views/activity/riTzCheck/index.vue')
      },
    ],
  },
  {
    path: '/goodHouseHealthService',
    meta: {
      title: '健康体检',
      navbar: false,
      needLogin: true
    },
    component: () => import('@/views/goodHouseHealthService/index.vue')
  },
  {
    path: '/generalDentistry',
    meta: {
      title: '全齿健',
      navbar: false,
      needLogin: true
    },
    component: () => import('@/views/generalDentistry/index.vue')
  },
  {
    path: '/writeOffCode',
    meta: {
      title: '我的核销码',
      navbar: false,
      needLogin: true
    },
    component: () => import('@/views/writeOffCode/index.vue')
  },
  {
    path: '/agreement',
    component: () => import('@/components/Layout.vue'),
    meta: {
      title: '协议',
    },
    children: [
      {
        path: 'privacyAgreement',
        name: 'PrivacyAgreement',
        meta: {
          title: '隐私协议',
          navbar: false,
          goBackApp: true,
        },
        component: () =>
          import('@/views/agreement/privacyAgreement/PrivacyAgreement.vue'),
      },
      {
        path: 'article',
        name: 'article',
        meta: {
          title: '',
          navbar: false,
          goBackApp: true,
          hasAppNav: 1,
          allowScale: true,
        },
        component: () =>
          import('@/views/agreement/article/Article.vue'),
      },
    ],
  },
  {
    path: '/allArticle',
    name: 'AllArticle',
    meta: {
      title: '健康资讯',
    },
    component: () => import('@/components/Layout.vue'),
    children: [
      {
        path: '',
        meta: {
          title: '健康资讯',
          navbar: false,
          needLogin: true,
          hasAppNav: 1
        },
        component: () => import('@/views/content/AllArticle.vue')
      }
    ]
  },
  {
    path: '/dentistry',
    name: 'Dentistry',
    component: () => import('@/components/Layout.vue'),
    redirect: '/dentistry/index',
    children: [
      {
        path: 'index',
        name: 'Index',
        meta: {
          title: '牙科活动',
          navbar: false,
          needLogin: true,
          hasAppNav: 0
        },
        component: () => import('@/views/dentistry/index.vue'),
      },
      {
        path: 'mycard',
        name: 'myCard',
        meta: {
          title: '我的卡券',
          needLogin: true,
          goBackApp: true,
          hasAppNav: 0
        },
        component: () => import('@/views/dentistry/myCard.vue'),
      },
      {
        path: 'invalid',
        name: 'Invalid',
        meta: {
          title: '无效卡券',
          hasAppNav: 0
        },
        component: () => import('@/views/dentistry/invalid.vue'),
      },
      {
        path: 'detail',
        name: 'Detail',
        meta: {
          title: '卡券详情',
          needLogin: true,
          hasAppNav: 0
        },
        component: () => import('@/views/dentistry/detail.vue'),
      },
      {
        path: 'orderDetail',
        name: 'OrderDetail',
        meta: {
          title: '订单详情',
          needLogin: true,
          goBackApp: true,
          hasAppNav: 0
        },
        component: () => import('@/views/dentistry/orderDetail.vue'),
      },
      {
        path: '/paySuccess',
        name: 'PaySuccess',
        meta: {
          title: '支付成功',
          navbar: false,
          needLogin: true,
          hasAppNav: 0
        },
        component: () => import('@/views/dentistry/result.vue'),
      },
    ],
  },
  {
    path: '/psychology',
    name: 'PsychologicalActivity',
    component: () => import('@/views/psychological/PsychologicalActivity.vue'),
    meta: {
      title: '心理咨询',
      needLogin618: true,
    },
  },
    // 人保心理咨询
  {
    path: '/renBaoPsychologicalActivity',
    name: 'renBaoPsychologicalActivity',
    component: () => import('@/views/psychological/renBaoPsychologicalActivity.vue'),
    meta: {
      title: '关爱热线',
      needLogin618: true,
    },
  },
  {
    path: '/transfer',
    component: () => import('@/components/Layout.vue'),
    meta: {
      title: '中转页',
    },
    children: [
      {
        path: '/vhall',
        name: 'Vhall',
        meta: {
          title: '微吼中转页',
          navbar: false,
          needLogin: true,
        },
        component: () =>
          import('@/views/transfer/toVHALL/ToVHALL.vue'),
      },
      {
        path: '/pharmacy',
        name: 'Pharmacy',
        meta: {
          title: '网药中转页',
          navbar: false,
        },
        component: () =>
          import('@/views/transfer/toPharmacy/ToPharmacy.vue'),
      },
    ],
  },
  {
    path: '/yunnan',
    component: () => import('@/components/Layout.vue'),
    meta: {
      title: '云南康养',
      hasAppNav: 0
    },
    children: [
      {
        path: '/yunnanHome',
        name: 'YunnanHome',
        component: () => import('@/views/yunnan/index.vue'),
        meta: {
          title: '永城用户专享',
          needLogin: true,
          navbar: true,
          goBackApp: true
        }
      },
      {
        path: '/goodsDetail',
        name: 'GoodsDetail',
        meta: {
          title: '商品详情',
          navbar: false,
        },
        component: () =>
          import('@/views/yunnan/detail.vue'),
      },
      {
        path: '/selectTime',
        name: 'SelectTime',
        meta: {
          title: '选择日期和人数',
          navbar: true,
        },
        component: () =>
          import('@/views/yunnan/selectTime.vue'),
      },
      {
        path: '/confirmInfo',
        name: 'ConfirmInfo',
        meta: {
          title: '确认信息',
          navbar: true,
        },
        component: () =>
          import('@/views/yunnan/confirmInfo.vue'),
      },
      {
        path: '/myFamily',
        name: 'MyFamily',
        meta: {
          title: '我的家人',
          navbar: false,
        },
        component: () =>
          import('@/views/yunnan/myFamily.vue'),
      },
      {
        path: '/addPeopleInfo',
        name: 'AddPeopleInfo',
        meta: {
          title: '家人信息',
          navbar: true,
        },
        component: () =>
          import('@/views/yunnan/AddPeopleInfo.vue'),
      },
      {
        path: '/updatePeopleInfo',
        name: 'UpdatePeopleInfo',
        meta: {
          title: '家人信息',
          navbar: true,
        },
        component: () =>
          import('@/views/yunnan/UpdatePeopleInfo.vue'),
      },
      {
        path: '/yunnanHome/paySuccess',
        name: 'PaySuccess',
        meta: {
          title: '支付结果',
          navbar: false,
        },
        component: () =>
          import('@/views/yunnan/result.vue'),
      },
      {
        path: '/orderDetail',
        name: 'OrderDetail',
        meta: {
          title: '订单详情',
          navbar: true,
          needLogin: true,
          goBackApp: true
        },
        component: () =>
          import('@/views/yunnan/orderDetail.vue'),
      },
    ],
  },
  {
    path: '/visitorInfoPage',
    component: () => import('@/views/visitorInfoPage/index.vue'),
    meta: {
      title: '访客信息承接页',
      navbar: false
    },
  },
  {
    path: '/huBeiService',
    component: () => import('@/components/Layout.vue'),
    meta: {
      title: '团险客户福利',
    },
    children: [
      {
        path: '/huBeiService/userLogin',
        name: 'UserLogin',
        meta: {
          title: '团险客户福利',
          navbar: false,
          needLogin: false,
        },
        component: () =>
          import('@/views/huBeiService/userLogin/index.vue'),
      },
      {
        path: '/huBeiService/serviceInfo',
        name: 'ServiceInfo',
        meta: {
          title: '团险客户福利',
          navbar: false,
          needLogin: false,
        },
        component: () =>
          import('@/views/huBeiService/serviceInfo/index.vue'),
      },
      {
        path: '/huBeiService/serviceList',
        name: 'ServiceList',
        meta: {
          title: '服务包列表',
          navbar: false,
          needLogin: false,
        },
        component: () =>
          import('@/views/huBeiService/serviceList/index.vue'),
      },
      {
        path: '/huBeiService/serviceDetail',
        name: 'ServiceDetail',
        meta: {
          title: '服务包详情',
          navbar: false,
          needLogin: false,
        },
        component: () =>
          import('@/views/huBeiService/serviceDetail/index.vue'),
      },
      { // 临时跳转的详情页
        path: '/huBeiService/serviceDetail/tempDetail',
        name: 'ServiceTempDetail',
        meta: {
          title: '服务包详情',
          navbar: false,
          needLogin: false,
        },
        component: () =>
          import('@/views/huBeiService/serviceDetail/tempDetail.vue'),
      },
      {
        path: '/huBeiService/serviceNoList',
        name: 'serviceNoList',
        meta: {
          title: '服务包列表',
          navbar: false,
          needLogin: false,
        },
        component: () =>
          import('@/views/huBeiService/serviceNoList/index.vue'),
      }
    ]
  },
  {
    path: '/marketing618',
    component: () => import('@/views/marketing618/index.vue'),
    meta: {
      title: '618营销活动',
      needLogin618: true,
      navbar: false
    },
  },


    // 平圩体检服务
  {
    path: '/pingweiService',
    name: 'pingweiService',
    component: () => import('@/components/Layout.vue'),
    meta: {
      title: '平圩体检',
      navbar: false
    },
    children: [
      {
        path: '/pingweiService/userLogin',
        name: 'pingweiServiceLogin',
        meta: {
          title: '平圩体检登录',
          navbar: false
        },
        component: () =>
            import('@/views/pingweiService/userLogin/index.vue'),
      },
      {
        path: '/pingweiService/serviceList',
        name: 'ServiceList',
        meta: {
          title: '平圩体检',
          navbar: false,
          needLoginPW: true
        },
        component: () =>
            import('@/views/pingweiService/serviceList/index.vue'),
      }
    ]
  },
    // 齿科专项服务
  {
    path: '/dentistryService',
    name: 'DentistryService',
    meta: {
      title: '健康资讯',
      navbar: false,
      needLogin: false,
      hasAppNav: 0
    },
    component: () => import('@/views/dentistryService/dentistryService.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})
// 对路由进入前进行处理
router.beforeEach(routerBeforeEach)
export default router
